export const JOB_TITLE = "jobTitle";
export const JOB_ROLE = "jobRole";
export const LOCATION = "location";
export const JOB_DESC = "jobDescription";
export const REQ_SKILLS = "requiredSkills";
export const EXP_REQ = "experienceRequired";
export const COMPANY_NAME = "companyName";
export const COMPANY_DESC = "companyDescription";
export const STATUS = "status";

export const companyOptions = [
  {
    label: "Ostwal Phoschem (India) Limited",
    value: "Ostwal Phoschem (India) Limited",
  },
  {
    label: "Madhya Bharat Agro Products Limited",
    value: "Madhya Bharat Agro Products Limited",
  },
  { label: "Krishna Phoschem Limited", value: "Krishna Phoschem Limited" },
  {
    label: "Shri Ganpati Fertilizers Limited",
    value: "Shri Ganpati Fertilizers Limited",
  },
  {
    label: "Seasons International Private Limited",
    value: "Seasons International Private Limited",
  },
  {
    label: "Nirmala Real Infrastructure Private Limited",
    value: "Nirmala Real Infrastructure Private Limited",
  },
  {
    label: "Strive4X Infotech Private Limited",
    value: "Strive4X Infotech Private Limited",
  },
  {
    label: "Smt. Nirmala Devi Ostwal Sewa Sansthan",
    value: "Smt. Nirmala Devi Ostwal Sewa Sansthan",
  },
];
